import React from "react";
import {
  Box,
  CircularProgress,
  Paper,
  Typography,
} from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SearchIcon from "@material-ui/icons/Search";

const wrapperSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "48px 24px",
};

export const EmptyState = () => (
  <Paper elevation={0} style={{ ...wrapperSx, backgroundColor: "#fafafa" }}>
    <SearchIcon style={{ fontSize: 48, color: "#9e9e9e", marginBottom: 16 }} />
    <Typography variant="h6" color="textSecondary">
      Select an article to view its DPP
    </Typography>
    <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
      Search by article reference above.
    </Typography>
  </Paper>
);

export const LoadingState = () => (
  <Box style={wrapperSx}>
    <CircularProgress />
    <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
      Loading DPP data…
    </Typography>
  </Box>
);

export const ErrorState = ({ message }) => (
  <Paper elevation={0} style={{ ...wrapperSx, backgroundColor: "#fdecea" }}>
    <ErrorOutlineIcon style={{ fontSize: 48, color: "#c62828", marginBottom: 16 }} />
    <Typography variant="h6" style={{ color: "#c62828" }}>
      Could not load DPP
    </Typography>
    {message && (
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
        {message}
      </Typography>
    )}
  </Paper>
);
